module.exports = __webpack_public_path__ + "img/9-1.aac35918.jpg";